/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AccountingCatalogDto } from '../models/accounting-catalog-dto';
import { FelGroupDto } from '../models/fel-group-dto';
import { MibiAnaInfoDto } from '../models/mibi-ana-info-dto';
import { MibiFormDto } from '../models/mibi-form-dto';
import { orderProfileCreateWksFavorite } from '../fn/order-profile/order-profile-create-wks-favorite';
import { OrderProfileCreateWksFavorite$Params } from '../fn/order-profile/order-profile-create-wks-favorite';
import { orderProfileDeleteFavorite } from '../fn/order-profile/order-profile-delete-favorite';
import { OrderProfileDeleteFavorite$Params } from '../fn/order-profile/order-profile-delete-favorite';
import { orderProfileGetAccessibleProfiles } from '../fn/order-profile/order-profile-get-accessible-profiles';
import { OrderProfileGetAccessibleProfiles$Params } from '../fn/order-profile/order-profile-get-accessible-profiles';
import { orderProfileGetAccountingCatalogs } from '../fn/order-profile/order-profile-get-accounting-catalogs';
import { OrderProfileGetAccountingCatalogs$Params } from '../fn/order-profile/order-profile-get-accounting-catalogs';
import { orderProfileGetFelGroups } from '../fn/order-profile/order-profile-get-fel-groups';
import { OrderProfileGetFelGroups$Params } from '../fn/order-profile/order-profile-get-fel-groups';
import { orderProfileGetMibiAnaInfo } from '../fn/order-profile/order-profile-get-mibi-ana-info';
import { OrderProfileGetMibiAnaInfo$Params } from '../fn/order-profile/order-profile-get-mibi-ana-info';
import { orderProfileGetMibiInfo } from '../fn/order-profile/order-profile-get-mibi-info';
import { OrderProfileGetMibiInfo$Params } from '../fn/order-profile/order-profile-get-mibi-info';
import { orderProfileGetProfileFegInfos } from '../fn/order-profile/order-profile-get-profile-feg-infos';
import { OrderProfileGetProfileFegInfos$Params } from '../fn/order-profile/order-profile-get-profile-feg-infos';
import { orderProfileGetProfileInfos } from '../fn/order-profile/order-profile-get-profile-infos';
import { OrderProfileGetProfileInfos$Params } from '../fn/order-profile/order-profile-get-profile-infos';
import { orderProfileGetSelectedProfileDetails } from '../fn/order-profile/order-profile-get-selected-profile-details';
import { OrderProfileGetSelectedProfileDetails$Params } from '../fn/order-profile/order-profile-get-selected-profile-details';
import { OrdProfileDto } from '../models/ord-profile-dto';
import { ProfileFegInfoDto } from '../models/profile-feg-info-dto';
import { SelectProfileResultDto } from '../models/select-profile-result-dto';

@Injectable({ providedIn: 'root' })
export class OrderProfileApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `orderProfileGetAccessibleProfiles()` */
  static readonly OrderProfileGetAccessibleProfilesPath = '/api/order-profile/profiles/{prtID}';

  /**
   * Get all profiles for the given order type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderProfileGetAccessibleProfiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileGetAccessibleProfiles$Response(params: OrderProfileGetAccessibleProfiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrdProfileDto>>> {
    const obs = orderProfileGetAccessibleProfiles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all profiles for the given order type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderProfileGetAccessibleProfiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileGetAccessibleProfiles(params: OrderProfileGetAccessibleProfiles$Params, context?: HttpContext): Observable<Array<OrdProfileDto>> {
    const resp = this.orderProfileGetAccessibleProfiles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OrdProfileDto>>): Array<OrdProfileDto> => r.body)
    );
  }

  /** Path part for operation `orderProfileGetFelGroups()` */
  static readonly OrderProfileGetFelGroupsPath = '/api/order-profile';

  /**
   * Get FelGroups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderProfileGetFelGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileGetFelGroups$Response(params?: OrderProfileGetFelGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FelGroupDto>>> {
    const obs = orderProfileGetFelGroups(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get FelGroups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderProfileGetFelGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileGetFelGroups(params?: OrderProfileGetFelGroups$Params, context?: HttpContext): Observable<Array<FelGroupDto>> {
    const resp = this.orderProfileGetFelGroups$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FelGroupDto>>): Array<FelGroupDto> => r.body)
    );
  }

  /** Path part for operation `orderProfileCreateWksFavorite()` */
  static readonly OrderProfileCreateWksFavoritePath = '/api/order-profile/favorites/wks';

  /**
   * Create a favorite.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderProfileCreateWksFavorite()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderProfileCreateWksFavorite$Response(params: OrderProfileCreateWksFavorite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = orderProfileCreateWksFavorite(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a favorite.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderProfileCreateWksFavorite$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderProfileCreateWksFavorite(params: OrderProfileCreateWksFavorite$Params, context?: HttpContext): Observable<void> {
    const resp = this.orderProfileCreateWksFavorite$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `orderProfileGetProfileFegInfos()` */
  static readonly OrderProfileGetProfileFegInfosPath = '/api/order-profile/feg-infos';

  /**
   * Get ProfileFegInfos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderProfileGetProfileFegInfos()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderProfileGetProfileFegInfos$Response(params: OrderProfileGetProfileFegInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileFegInfoDto>>> {
    const obs = orderProfileGetProfileFegInfos(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get ProfileFegInfos.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderProfileGetProfileFegInfos$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderProfileGetProfileFegInfos(params: OrderProfileGetProfileFegInfos$Params, context?: HttpContext): Observable<Array<ProfileFegInfoDto>> {
    const resp = this.orderProfileGetProfileFegInfos$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ProfileFegInfoDto>>): Array<ProfileFegInfoDto> => r.body)
    );
  }

  /** Path part for operation `orderProfileGetAccountingCatalogs()` */
  static readonly OrderProfileGetAccountingCatalogsPath = '/api/order-profile/accounting-catalogs';

  /**
   * Get the accounting catalogs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderProfileGetAccountingCatalogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileGetAccountingCatalogs$Response(params?: OrderProfileGetAccountingCatalogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccountingCatalogDto>>> {
    const obs = orderProfileGetAccountingCatalogs(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the accounting catalogs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderProfileGetAccountingCatalogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileGetAccountingCatalogs(params?: OrderProfileGetAccountingCatalogs$Params, context?: HttpContext): Observable<Array<AccountingCatalogDto>> {
    const resp = this.orderProfileGetAccountingCatalogs$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AccountingCatalogDto>>): Array<AccountingCatalogDto> => r.body)
    );
  }

  /** Path part for operation `orderProfileDeleteFavorite()` */
  static readonly OrderProfileDeleteFavoritePath = '/api/order-profile/favorites/{favID}';

  /**
   * Delete a favorite.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderProfileDeleteFavorite()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileDeleteFavorite$Response(params: OrderProfileDeleteFavorite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = orderProfileDeleteFavorite(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a favorite.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderProfileDeleteFavorite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileDeleteFavorite(params: OrderProfileDeleteFavorite$Params, context?: HttpContext): Observable<void> {
    const resp = this.orderProfileDeleteFavorite$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `orderProfileGetSelectedProfileDetails()` */
  static readonly OrderProfileGetSelectedProfileDetailsPath = '/api/order-profile/selected-profile-details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderProfileGetSelectedProfileDetails()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderProfileGetSelectedProfileDetails$Response(params: OrderProfileGetSelectedProfileDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectProfileResultDto>> {
    const obs = orderProfileGetSelectedProfileDetails(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderProfileGetSelectedProfileDetails$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderProfileGetSelectedProfileDetails(params: OrderProfileGetSelectedProfileDetails$Params, context?: HttpContext): Observable<SelectProfileResultDto> {
    const resp = this.orderProfileGetSelectedProfileDetails$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SelectProfileResultDto>): SelectProfileResultDto => r.body)
    );
  }

  /** Path part for operation `orderProfileGetMibiInfo()` */
  static readonly OrderProfileGetMibiInfoPath = '/api/order-profile/mibi/for-template/{tplId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderProfileGetMibiInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileGetMibiInfo$Response(params: OrderProfileGetMibiInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<MibiFormDto>> {
    const obs = orderProfileGetMibiInfo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderProfileGetMibiInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileGetMibiInfo(params: OrderProfileGetMibiInfo$Params, context?: HttpContext): Observable<MibiFormDto> {
    const resp = this.orderProfileGetMibiInfo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MibiFormDto>): MibiFormDto => r.body)
    );
  }

  /** Path part for operation `orderProfileGetProfileInfos()` */
  static readonly OrderProfileGetProfileInfosPath = '/api/order-profile/profile-infos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderProfileGetProfileInfos()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderProfileGetProfileInfos$Response(params: OrderProfileGetProfileInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrdProfileDto>>> {
    const obs = orderProfileGetProfileInfos(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderProfileGetProfileInfos$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderProfileGetProfileInfos(params: OrderProfileGetProfileInfos$Params, context?: HttpContext): Observable<Array<OrdProfileDto>> {
    const resp = this.orderProfileGetProfileInfos$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OrdProfileDto>>): Array<OrdProfileDto> => r.body)
    );
  }

  /** Path part for operation `orderProfileGetMibiAnaInfo()` */
  static readonly OrderProfileGetMibiAnaInfoPath = '/api/order-profile/mibi/ana-info/{prfId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderProfileGetMibiAnaInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileGetMibiAnaInfo$Response(params: OrderProfileGetMibiAnaInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<MibiAnaInfoDto>> {
    const obs = orderProfileGetMibiAnaInfo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderProfileGetMibiAnaInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderProfileGetMibiAnaInfo(params: OrderProfileGetMibiAnaInfo$Params, context?: HttpContext): Observable<MibiAnaInfoDto> {
    const resp = this.orderProfileGetMibiAnaInfo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MibiAnaInfoDto>): MibiAnaInfoDto => r.body)
    );
  }

}
